import { MdFlag } from '@teamworksdev/icons';

export const CollectionFlag = () => (
  <MdFlag className="ml-1" color="blue" size={15} />
);
